import { Block } from "@components/block";
import { Grid, GridCol } from "@components/grid";
import { Input } from "@components/input";
import { FlexLoader } from "@components/loader";
import { CustomSelect } from "@components/select";
import { BalancesModal } from "@components/userModals/balance";
import { useAdminUsers } from "@features/admin/users";
import { UserInfoBalance } from "@features/admin/users/api";
import { useAuth } from "@features/auth";
import { useBoolState } from "@hooks/use-bool-state";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { UserBlockProps } from "..";
import { ComissionModal } from "../comissionModal";
import { Button } from "@components/button";
import styles from "../selectedUser.module.scss";

export const TraderBlock = ({ control }: UserBlockProps) => {
  const { selectedUserId } = useParams();
  const { state } = useAdminUsers();

  const [userBalance, setUserBalance] = useState<UserInfoBalance | null>(null);
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [isCommissionModalOpen, showCommissionModal, hideCommissionModal] =
    useBoolState(false);
  const [title, setTitle] = useState("");
  const [balanceType, setBalanceType] = useState("");
  const { isAdmin, isSuperUser } = useAuth();

  // const { control } = useForm();
  const onOffOption = [
    { text: "Вкл", value: "true" },
    { text: "Выкл", value: "false" },
  ];
  const bassBoosted = [
    { text: "Базовый", value: "false" },
    { text: "Буст", value: "true" },
  ];
  const openModalOnBalance = (type: string) => {
    if (state.userInfo == null || state.userInfo.kind != "trader") return;
    switch (type) {
      case "Trust":
        setTitle("Трастовый баланс");
        setUserBalance(state.userInfo.trust_balance);
        setBalanceType("trust");
        break;
      case "Frozen":
        setTitle("Замороженный баланс");
        setUserBalance(state.userInfo.frozen_balance);
        setBalanceType("frozen");
        break;
      case "Ern_Pay_IN":
        setTitle("Доход сделки");
        setUserBalance(state.userInfo.ern_balance);
        setBalanceType("Ern_Pay_IN");
        break;
      case "Ern_Pay_OUT":
        setTitle("Доход выводы");
        setUserBalance(state.userInfo.ern_balance);
        setBalanceType("Ern_Pay_OUT");
        break;
      case "Save":
        setTitle("Страховой баланс");
        setUserBalance(state.userInfo.save_balance);
        setBalanceType("save");
        break;
    }
    showModal();
  };
  return (
    <>
      <Block className={styles.block}>
        <h3>Трейдер</h3>
        {state.loading ? (
          <FlexLoader />
        ) : (
          <Grid>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={() => openModalOnBalance("Trust")}
                disabled={!isSuperUser}
              >
                Трастовый баланс
              </Button>
            </GridCol>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={() => openModalOnBalance("Frozen")}
                disabled={!isSuperUser}
              >
                Замороженный баланс
              </Button>
            </GridCol>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={() => openModalOnBalance("Ern_Pay_IN")}
                disabled={!isSuperUser}
              >
                Доход сделки
              </Button>
            </GridCol>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={() => openModalOnBalance("Ern_Pay_OUT")}
                disabled={!isSuperUser}
              >
                Доход выводы
              </Button>
            </GridCol>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={() => openModalOnBalance("Save")}
                disabled={!isSuperUser}
              >
                Страховой баланс
              </Button>
            </GridCol>
            <GridCol span={3}>
              <Button
                buttonType="button"
                onClick={showCommissionModal}
                disabled={!isSuperUser}
              >
                Комиссии
              </Button>
            </GridCol>
            <GridCol span={3}>
              <CustomSelect
                control={control}
                options={onOffOption}
                name="allow_farm_creation"
                label="Ферма"
                disabled={!isAdmin}
              ></CustomSelect>
            </GridCol>
            <GridCol span={3}>
              <CustomSelect
                control={control}
                options={onOffOption}
                name="pay_in"
                label="Pay-in"
                disabled={!isAdmin}
              ></CustomSelect>
            </GridCol>
            <GridCol span={3}>
              <CustomSelect
                control={control}
                options={onOffOption}
                name="pay_out"
                label="Pay-out"
                disabled={!isAdmin}
              ></CustomSelect>
            </GridCol>
            <GridCol span={3}>
              <CustomSelect
                control={control}
                options={bassBoosted}
                name="boosted"
                label="Базовый / Бустед"
                disabled={!isAdmin}
              ></CustomSelect>
            </GridCol>
            <GridCol span={3}>
              <CustomSelect
                control={control}
                options={onOffOption}
                name="allow_requisites_without_device"
                label="Реквизиты без устройства"
                disabled={!isAdmin}
              ></CustomSelect>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="min_sum_order"
                control={control}
                type="number"
                placeholder="Мин сумма ордера Pay-in"
                label="Мин сумма ордера Pay-in"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="max_sum_order"
                control={control}
                type="number"
                placeholder="Макс сумма ордера Pay-in"
                label="Макс сумма ордера Pay-in"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="min_sum_pay_out_order"
                control={control}
                type="number"
                placeholder="Мин сумма ордера Pay-out"
                label="Мин сумма ордера Pay-out"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="max_sum_pay_out_order"
                control={control}
                type="number"
                placeholder="Макс сумма ордера Pay-out"
                label="Макс сумма ордера Pay-out"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
            <GridCol span={3}>
              <Input
                name="team_lead_commission_pay_in"
                control={control}
                type="number"
                placeholder="Комиссия тимлида pay-in"
                label="Комиссия тимлида pay-in"
                disabled={!isSuperUser}
              ></Input>
            </GridCol>
          </Grid>
        )}
      </Block>
      {userBalance != null &&
        userBalance.id.length > 0 &&
        selectedUserId != null && (
          <BalancesModal
            isModalOpen={isModalOpen}
            hideModal={hideModal}
            title={title}
            type={balanceType}
            userBalance={userBalance}
            userId={selectedUserId}
          />
        )}
      <ComissionModal
        isOpen={isCommissionModalOpen}
        onClose={hideCommissionModal}
        control={control}
        isTrader={true}
      />
    </>
  );
};